var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * Gunavant Jambu
 * Created Seprate Component for reuse in another project.
 *
 * Pending: implementation of handleApplyNow
 */
import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button, Modal, Spinner } from "react-bootstrap";
import CloseButton from "react-bootstrap/CloseButton";
import NumberFormat from "react-number-format";
import { UserSession } from "usersession";
import ApplyNowPost from "./ApplyNowPost";
import axios from "axios";
import "./css/ApplyNow.css";

//  Custom CSS
var treasury = {
  opacity: 0,
  position: "absolute"
};
// End of Custom CSS

function ApplyNow(props) {
  var userSession = new UserSession();

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      extPropertyState = _useState2[0],
      setPropertyState = _useState2[1];

  var _useState3 = useState(""),
      _useState4 = _slicedToArray(_useState3, 2),
      extFirstName = _useState4[0],
      setFirstName = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      extLastName = _useState6[0],
      setLastName = _useState6[1];

  var _useState7 = useState(""),
      _useState8 = _slicedToArray(_useState7, 2),
      extPhone = _useState8[0],
      setPhone = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      phoneNumberError = _useState10[0],
      setPhoneNumberError = _useState10[1];

  var _useState11 = useState(""),
      _useState12 = _slicedToArray(_useState11, 2),
      extEmail = _useState12[0],
      setEmail = _useState12[1];

  var _useState13 = useState(""),
      _useState14 = _slicedToArray(_useState13, 2),
      statesOptions = _useState14[0],
      setStatesOptions = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      showModal = _useState16[0],
      setShowVM = _useState16[1];

  var _useState17 = useState(""),
      _useState18 = _slicedToArray(_useState17, 2),
      leadGenerated = _useState18[0],
      setLead = _useState18[1];

  var _useState19 = useState(""),
      _useState20 = _slicedToArray(_useState19, 2),
      leadData = _useState20[0],
      setLeadData = _useState20[1];

  var _useState21 = useState(true),
      _useState22 = _slicedToArray(_useState21, 2),
      consent = _useState22[0],
      setConsent = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      honeyPot = _useState24[0],
      setHoneyPot = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      formLoading = _useState26[0],
      setFormLoading = _useState26[1];

  var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      successPopup = _useState28[0],
      setSuccessPopup = _useState28[1];

  var _useState29 = useState(false),
      _useState30 = _slicedToArray(_useState29, 2),
      redirectPage = _useState30[0],
      setRedirectPage = _useState30[1];

  var _useState31 = useState(false),
      _useState32 = _slicedToArray(_useState31, 2),
      validated = _useState32[0],
      setValidated = _useState32[1];

  var offerLoanType = "";

  switch (props.data.loanType) {
    case "Conventional":
      offerLoanType = "200";
      break;
    case "FHA":
      offerLoanType = "111";
      break;
    case "VA":
      offerLoanType = "120";
      break;
    case "USDA":
      offerLoanType = "130";
      break;
    //no default
  }

  // This function close the modal the capture the ratequote leads, clean the form and set the differents conditions to false.
  var handleVMClose = function handleVMClose() {
    setShowVM(false);
    setValidated(false);
    ClearForm();
    setSuccessPopup(false);
    setRedirectPage(false);
    setFormLoading(false);
  };

  function saveSelectedProductDetails(selectedProduct) {
    userSession.getSelectedProduct().setLoanType(selectedProduct.loanType);
    userSession.getSelectedProduct().setLoanTerm(selectedProduct.loanTerm);
    userSession.getSelectedProduct().setProductCode(selectedProduct.productCode);
    userSession.getSelectedProduct().setLoanAmount(selectedProduct.loanAmount);
    userSession.getSelectedProduct().setPrice(selectedProduct.price);
    userSession.getSelectedProduct().setRate(selectedProduct.rate);
    userSession.getSelectedProduct().setMargin(selectedProduct.margin);
    userSession.getSelectedProduct().setLockPeriod(selectedProduct.lockPeriod);
    userSession.getSelectedProduct().setEstClosingCost(selectedProduct.estClosingCost);
    userSession.getSelectedProduct().setCredit(selectedProduct.credit);
    userSession.getSelectedProduct().setApr(selectedProduct.apr);
    userSession.getSelectedProduct().setPI(selectedProduct.PI);
  }

  var CreateLead = function CreateLead(event) {
    userSession.loadCustomQuoteData();
    saveSelectedProductDetails(props.data);

    var form = event.currentTarget;
    event.preventDefault();
    var createLeadForm = document.getElementById("createLeadForm");

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      if (!honeyPot) {
        var ssLeadData = {
          propertyAddressState: extPropertyState,
          borrower: {
            firstName: extFirstName,
            lastName: extLastName,
            phone: extPhone,
            email: extEmail,
            TCPA_Consent_Given: consent
          },
          leadSource: userSession.getLeadSource(),
          offerLoanType: offerLoanType,
          offerLoanProductCode: userSession.getSelectedProduct().getProductCode(),
          loanPurpose: userSession.getLoanPurposeCode(),
          offerRate: userSession.getSelectedProduct().getRate(),
          offerTerm: props.data.loanTerm,
          branch: userSession.getBranchCode(),
          promoCode: userSession.getPromoCode(),
          message: "RateQuote lead"
        };

        setFormLoading(true);

        // Create lead in Sunsoft
        axios.post(process.env.REACT_APP_SUNSOFT_API_CREATE_SESSION_AND_LEAD, ssLeadData, {
          headers: { "Content-Type": "application/json" }
        }).then(function (res) {
          var bodyResponse = res.data.body;

          if (bodyResponse.leadNumber) {
            var leadNumber = {
              applicationNumber: bodyResponse.leadNumber
            };

            setLead(bodyResponse.leadNumber);
            setLeadData(leadNumber);

            ClearForm();
            setSuccessPopup(true);
            setValidated(false);
            setFormLoading(false);
            createLeadForm.classList.remove("was-validated");
            createLeadForm.reset();
          } else {
            setLead("");
            ClearForm();
            setLeadData(ssLeadData);
            setValidated(false);
            setFormLoading(false);
            setSuccessPopup(true);
            createLeadForm.classList.remove("was-validated");
            createLeadForm.reset();
          }
        }).catch(function (e) {
          console.log(e);
          setLeadData(ssLeadData);
          ClearForm();
          setValidated(false);
          setFormLoading(false);
          setSuccessPopup(true);
        });
      }
    }
    setValidated(true);
  };

  function updateState(data) {
    setPropertyState(data);
    userSession.setPropertyState(data);
  }

  function ClearForm() {
    setPhone("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setConsent(true);
  }

  useEffect(function () {
    if (!React.version.startsWith('17')) {
      console.error("ApplyNow requires react version 17.0.2 in order to avoid react hook error. The current version of react is " + React.version);
    }

    var stateList = JSON.parse(userSession.getStateList());

    setStatesOptions(stateList.map(function (item, index) {
      return React.createElement(
        "option",
        { key: index, value: item.code },
        item.name
      );
    }));
    setPropertyState(userSession.getPropertyState());
  }, []);

  return React.createElement(
    React.Fragment,
    null,
    React.createElement(
      Modal,
      {
        id: "leadModal",
        size: "lg",
        centered: true,
        show: showModal,
        onHide: handleVMClose,
        backdrop: "static"
      },
      React.createElement(
        Modal.Header,
        null,
        !successPopup && !formLoading || !formLoading && successPopup ? React.createElement(CloseButton, { onClick: handleVMClose }) : null
      ),
      React.createElement(
        Modal.Body,
        { className: "pt-0" },
        !formLoading && !successPopup ? React.createElement(
          Form,
          {
            method: "post",
            onSubmit: CreateLead,
            id: "createLeadForm",
            noValidate: true,
            validated: validated
          },
          React.createElement(
            Row,
            null,
            React.createElement(
              "h2",
              { className: "titleh2 mb-3" },
              "Please fill the information below to continue"
            )
          ),
          React.createElement(
            Row,
            { style: treasury },
            React.createElement(
              Form.Group,
              { as: Col, sm: 5, controlId: "quote_name_lead" },
              React.createElement(
                "strong",
                null,
                React.createElement(
                  Form.Label,
                  null,
                  "* Get Quote Name: "
                )
              ),
              React.createElement(Form.Control, {
                autoComplete: "new-password",
                type: "password",
                minLength: "2",
                maxLength: "12",
                "data-error": "Please fill out this field correctly.",
                onChange: function onChange() {
                  setHoneyPot(true);
                }
              }),
              React.createElement(Form.Control.Feedback, { type: "invalid" })
            ),
            React.createElement(
              Form.Group,
              { as: Col, sm: 5, controlId: "quote_code_lead" },
              React.createElement(
                "strong",
                null,
                React.createElement(
                  Form.Label,
                  null,
                  "* Get Quote Code: "
                )
              ),
              React.createElement(Form.Control, {
                autoComplete: "new-password",
                type: "password",
                pattern: "^[0-9a-zA-Z]{4}$",
                maxLength: "4",
                "data-error": "Please fill out this field correctly.",
                onChange: function onChange() {
                  setHoneyPot(true);
                }
              }),
              React.createElement(Form.Control.Feedback, { type: "invalid" })
            )
          ),
          React.createElement(
            Form.Row,
            null,
            React.createElement(
              Form.Group,
              { as: Col, sm: 12, md: 6 },
              React.createElement(Form.Control, {
                type: "text",
                name: "first_name",
                value: extFirstName,
                autoComplete: "on",
                placeholder: "Your First Name",
                required: true,
                onChange: function onChange(e) {
                  return setFirstName(e.target.value);
                }
              }),
              React.createElement(
                Form.Control.Feedback,
                { type: "invalid" },
                "Please enter a First Name."
              )
            ),
            React.createElement(
              Form.Group,
              { as: Col, sm: 12, md: 6 },
              React.createElement(Form.Control, {
                type: "text",
                name: "last_name",
                value: extLastName,
                autoComplete: "on",
                placeholder: "Your Last Name",
                required: true,
                onChange: function onChange(e) {
                  return setLastName(e.target.value);
                }
              }),
              React.createElement(
                Form.Control.Feedback,
                { type: "invalid" },
                "Please enter a Last Name."
              )
            ),
            React.createElement(
              Form.Group,
              { as: Col, sm: 12, md: 6 },
              React.createElement(Form.Control, {
                type: "email",
                name: "email",
                value: extEmail,
                autoComplete: "on",
                placeholder: "Your Email",
                required: true,
                onChange: function onChange(e) {
                  return setEmail(e.target.value);
                }
              }),
              React.createElement(
                Form.Control.Feedback,
                { type: "invalid" },
                "Please provide a valid email."
              )
            ),
            React.createElement(
              Form.Group,
              { as: Col, sm: 12, md: 6 },
              React.createElement(NumberFormat, {
                name: "phone",
                type: "tel",
                placeholder: "Your Phone Number",
                value: extPhone,
                onValueChange: function onValueChange(values) {
                  setPhone(values.value);
                  if (values.value.toString().length === 10 || values.value.toString().length === 0) {
                    setPhoneNumberError(false);
                  } else {
                    setPhoneNumberError(true);
                  }
                },
                className: "form-control form-control-sm",
                format: "+1 (###) ###-####",
                mask: "_",
                autoComplete: "on"
              }),
              phoneNumberError && React.createElement(
                Form.Control.Feedback,
                { type: "invalid" },
                extPhone.toString().length <= 9 ? "Please provide a valid number." : ""
              )
            ),
            React.createElement(
              Form.Group,
              { as: Col },
              React.createElement(
                Form.Control,
                {
                  value: extPropertyState,
                  name: "propertyState",
                  placeholder: "Property State",
                  onChange: function onChange(e) {
                    updateState(e.target.value);
                  },
                  as: "select",
                  custom: true
                },
                React.createElement(
                  "option",
                  { value: "" },
                  "Your State"
                ),
                statesOptions
              )
            )
          ),
          React.createElement(
            "div",
            { className: "consentDesc" },
            React.createElement(
              "p",
              { className: "mt-2 mb-1" },
              React.createElement(
                "strong",
                null,
                "Phone Solicitation Consent"
              )
            ),
            React.createElement(
              "p",
              { className: "m-0" },
              "By clicking I CONSENT below, you expressly consent to Sun West Mortgage Company, Inc. making (or allowing to be made on its behalf) a phone call, text message, or voicemail transmission to the phone number you entered above for the purpose of soliciting your purchase of consumer goods or services (including using an automated system for the selection or dialing of phone numbers, the playing of a recorded message when a connection is made, or the transmission of a pre-recorded voicemail), even if that phone number is a on a national, state, or internal Do Not Call Registry. You are not required to click on I CONSENT below (directly or indirectly) or agree to receive such phone calls, text messages, or voicemail transmissions as a condition of obtaining any goods or services from Sun West Mortgage Company, Inc. or its affiliates."
            ),
            React.createElement(
              "p",
              { className: "mt-1" },
              "By pressing Get Started, you also agree to Sun West Mortgage Company, Inc.'s",
              " ",
              React.createElement(
                "a",
                {
                  href: "https://www.swmc.com/terms-and-conditions",
                  target: "_blank",
                  rel: "noopener noreferrer"
                },
                "Terms and Conditions"
              ),
              " ",
              "and",
              " ",
              React.createElement(
                "a",
                {
                  href: "https://www.swmc.com/privacy-policy",
                  target: "_blank",
                  rel: "noopener noreferrer"
                },
                "Security and Privacy Policy"
              ),
              ", which you may access by clicking on those terms. By communicating with Sun West Mortgage Company, Inc. by phone, you consent to phone calls being recorded and monitored."
            ),
            React.createElement(
              "div",
              null,
              React.createElement(Form.Check, {
                inline: true,
                type: "checkbox",
                label: "I consent",
                value: "Yes",
                className: "mr-3",
                onChange: function onChange() {
                  return setConsent(true);
                },
                checked: consent === true
              }),
              React.createElement(Form.Check, {
                inline: true,
                type: "checkbox",
                label: "I do not consent",
                value: "No",
                checked: consent === false,
                onChange: function onChange() {
                  return setConsent(false);
                }
              })
            )
          ),
          React.createElement(
            "div",
            { className: "text-center my-2" },
            React.createElement(
              Button,
              {
                variant: "primary",
                type: "submit",
                className: "submitButton"
              },
              "Get Started"
            )
          )
        ) : null,
        formLoading && !successPopup ? React.createElement(
          "div",
          { className: "text-center" },
          React.createElement(
            "h2",
            { className: "loaderh2" },
            "Your details are being processed"
          ),
          React.createElement(Spinner, {
            as: "span",
            animation: "border",
            size: "md",
            role: "status",
            "aria-hidden": "true",
            variant: "primary"
          })
        ) : null,
        successPopup && !formLoading ? React.createElement(
          "div",
          { className: "successDiv" },
          React.createElement("img", { src: "data:image/png;base64,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" }),
          React.createElement(
            "p",
            null,
            "Thank you for contacting us. We have received your request and one of our licensed and experienced mortgage professional will get back to you as soon as possible."
          ),
          leadGenerated ? React.createElement(
            "p",
            null,
            "Your Reference Number is: ",
            React.createElement(
              "strong",
              null,
              leadGenerated
            )
          ) : null,
          React.createElement(
            Button,
            {
              className: "successButton",
              onClick: function onClick() {
                setRedirectPage(true);
              }
            },
            "Continue"
          )
        ) : null
      )
    ),
    props.leadSource === "BLCHMWEB" ? React.createElement(
      Col,
      null,
      React.createElement(
        "span",
        { className: "btnApplyNow" },
        props.children
      )
    ) : React.createElement(
      Col,
      null,
      React.createElement(
        Button,
        { className: "btnApplyNow", onClick: function onClick() {
            return setShowVM(true);
          } },
        props.children
      )
    ),
    leadData && redirectPage ? React.createElement(ApplyNowPost, { ssLeadData: leadData, closeModal: handleVMClose }) : null
  );
}

export default ApplyNow;